import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useLoadProgress } from '../hooks/useLoadProgress'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: true,
    // login: false,
    title: '網路問卷通行碼（調查表正面右上角）',
    placeholder: '1 碼英文+5 碼數字，如：Z12345',
    alert: '通行碼有誤，請重新登入，或洽客服詢問 02-23315133 #601~604 羅小姐',
    useUserIdLogin: true,
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 暫存需加
  const [isReady, setIsReady] = useState(false)
  const userIdRef = useRef(null)
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q16: '{q15} anyof [0, 1, 2, 3, 4, 5, "other"]',
    q17: '{q15} anyof [0, 1, 2, 3, 4, 5, "other"]',
    q18: '({q15} anyof [0, 1, 2, 3, 4, 5, "other"]) and {q17} = 0',

    q28: '{q27} = 0',
    q29: '{q27} = 0',
    q30: '{q27} = 0',
    q31: '{q27} = 0',
    q32: '{q27} = 0',
    q33: '{q27} = 0',
    q34: '{q27} = 0',
    q35: '{q27} = 0',

    q40: '{q39} = 0',

    q50: '{q49} = 0',
    q51: '{q49} = 0',
    q52: '{q49} = 0',
    q53: '{q49} = 0',
    q54: '{q49} = 0',

    q65: '{q64} = 1',
    q67: '{q66} = 1',
    q69: '{q68} = 1',
    q71: '{q70} = 1',
    q73: '{q72} = 1',

    q76: '{q75} = 2',
    q77: '{q75} = 3',
    q79: '{q78} = 2',
    q80: '{q78} = 3',
    q82: '{q81} = 2',
    q83: '{q81} = 3',

    q85: '{q84} = 2',
    q86: '{q84} = 3',

    q87: '{q84} = 0 or {q84} = 1',
    q88: '{q84} = 0 or {q84} = 1',
    q89: '{q84} = 0 or {q84} = 1',
    q90: '{q84} = 0 or {q84} = 1',

    q92: '{q91} = 0',
    q93: '{q91} = 1',
    q94: '{q91} = 2',
    q95: '{q91} = 3',
    q96: '{q91} = 0 or {q91} = 1',

    q98: '{q97} = 0',
    q99: '({q97} = 0) and ({q98} anyof [0, 1, 2])',
    q100: '({q97} = 0) and ({q98} anyof [0, 1, 2])',

    q101: '({q97} = 0) and ({q98} anyof [0, 1, 2]) and ({q100} = 0)',
    q102: '({q97} = 0) and ({q98} anyof [0, 1, 2]) and ({q100} = 0) and ({q101} anyof [1])',
    q103: '({q97} = 0) and ({q98} anyof [0, 1, 2]) and ({q100} = 0) and ({q101} anyof [3])',

    q106: '{q105} = 2',
    q107: '({q105} = 2) and ({q106} = 1)',
    q108: '({q105} = 2) and ({q106} = 3)',
    q111: '{q110} = 0',
    q112: '{q110} = 0',
    q113: '{q110} = 0',
    q114: '{q110} = 0',

    q116: '{q115} anyof [0, 1, 2, 3, 4, 5, "other"]',

    q126: '{q125} = 0',

    q127: '({q125} = 0) and ({q126} anyof [10])',
    q128: '({q125} = 0) and ({q126} anyof [21])',
    q129: '({q125} = 0) and ({q126} anyof [22])',

    q130: '{q125} = 0',
    q131: '{q125} = 0',
    q132: '{q125} = 0',
    q133: '{q125} = 0',
    q134: '{q125} = 0',

    q136: '{q135} = 0 or {q135} = 1 or {q135} = 2',
    q137: '({q135} = 0 or {q135} = 1 or {q135} = 2) and ({q136} anyof [10])',
    q138: '({q135} = 0 or {q135} = 1 or {q135} = 2) and ({q136} anyof [21])',
    q139: '({q135} = 0 or {q135} = 1 or {q135} = 2) and ({q136} anyof [22])',
    q140: '{q135} = 0 or {q135} = 1 or {q135} = 2',

    q147: '{q146} = 2 or {q146} = 3',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q1} = 0 or {q1} = 7) or ({q3} anyof [0, 1, 2] ) or ({q4} notcontains [3] ) or ({q5} anyof ["none"]) or ({q6} = 3)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    // 暫存需加
    userIdRef,
    choiceIndexMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 暫存需加
  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  // 暫存需加
  useLoadProgress({
    surveyModel: surveyModel, // 若 myAgreeJson 為 null，agreeSurvey 亦為 null
    convertedSurvey: myAgreeJson,
    isReady,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
  })

  // 暫存需加
  // SurveyModel 初始化完成 → 標記可互動
  useEffect(() => {
    if (agreeSurvey) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [agreeSurvey])

  // 設置 survey 準備就緒狀態
  useEffect(() => {
    if (surveyModel) {
      // 給 survey 一些時間完成初始化
      setTimeout(() => {
        setIsReady(true)
      }, 50)
    }
  }, [surveyModel])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    console.log('AA', survey.getValue('q3'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  // expression: `({q1} = 0 or {q1} = 7) or ({q3} anyof [0, 1, 2] ) or ({q4} notcontains [3] ) or ({q5} anyof ["none"]) or ({q6} = 3)`,

  const endSurveyMsg = (survey) => {
    // if (
    //   survey.getValue('q1') === 0 ||
    //   survey.getValue('q1') === 7 ||
    //   survey.getValue('q3').some((v) => v === 0 || v === 1 || v === 2) ||
    //   !survey.getValue('q4').includes(3) ||
    //   survey.getValue('q5')[0] === 'none' ||
    //   survey.getValue('q6') === 3
    // ) {
    //   setCompletionMessage(endMessage)
    // } else {
    //   setCompletionMessage(
    //     `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
    //   )
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    // 暫存需加
    requiresLogin,
    userIdRef, // 傳入 ref 而不是直接傳 userId
    enableProgressSaving: requiresLogin.login, // 根據登入需求啟用
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
